<template>
    <div>
      <div v-if="loading" class="loading"></div>

      <template v-else>
        <template v-if="showNoAvailabilityErrorMessage === false">
          <div :key="apartmentListingKey" class="apartment-listing">
            <div class="apartment-card" v-for="(room, key) in filteredRooms" :key="key">
              <div class="apartment-card-img">
                <img src="data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" :data-src="room.image" class="object-fit lazyload">
              </div>
              <div class="apartment-card-content">
                <h3 style="margin-bottom: 1.5rem;">
                  <a :href="room.permalink | formatPermalink">{{ room.post_title }}</a>
                </h3>
                <div class="block-specs">
                  <div class="feat has-tooltip">
                    <div class="icon-with-tooltip">
                      <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>bed</title><path d="M42.854,21.512v-11.5a1,1,0,0,0-1-1H6.156a1,1,0,0,0-1,1V21.5A2.99,2.99,0,0,0,4,23.853V34.888a1,1,0,0,0,1,1H8.411v2.105a1,1,0,0,0,2,0V35.888H37.469v2.105a1,1,0,0,0,2,0V35.888H43a1,1,0,0,0,1-1V23.853A2.986,2.986,0,0,0,42.854,21.512ZM6,23.853a1,1,0,0,1,1-1H41a1,1,0,0,1,1,1V26.37H6Zm6-4v-3a1,1,0,0,1,1-1h7.307a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H13A1,1,0,0,1,12,19.851Zm14.693,0v-3a1,1,0,0,1,1-1H35a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H27.693A1,1,0,0,1,26.693,19.851ZM7.156,11.007h33.7v9.844H37.816a2.966,2.966,0,0,0,.184-1v-3a3,3,0,0,0-3-3H27.693a3,3,0,0,0-3,3v3a2.967,2.967,0,0,0,.185,1H23.122a2.967,2.967,0,0,0,.185-1v-3a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v3a2.966,2.966,0,0,0,.184,1H7.156ZM6,33.888V28.37H42v5.518Z"/></svg>
                      <div class="info"><span>i</span></div>
                    </div>
                    <p>{{ room.number_of_bedrooms }} {{ $t('bedrooms') }}</p>

                    <div class="feat-tooltip">
                      <div class="room-spec" v-if="room.number_of_bedrooms > 0">
                        <svg width="38" height="38" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>bed</title><path d="M42.854,21.512v-11.5a1,1,0,0,0-1-1H6.156a1,1,0,0,0-1,1V21.5A2.99,2.99,0,0,0,4,23.853V34.888a1,1,0,0,0,1,1H8.411v2.105a1,1,0,0,0,2,0V35.888H37.469v2.105a1,1,0,0,0,2,0V35.888H43a1,1,0,0,0,1-1V23.853A2.986,2.986,0,0,0,42.854,21.512ZM6,23.853a1,1,0,0,1,1-1H41a1,1,0,0,1,1,1V26.37H6Zm6-4v-3a1,1,0,0,1,1-1h7.307a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H13A1,1,0,0,1,12,19.851Zm14.693,0v-3a1,1,0,0,1,1-1H35a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H27.693A1,1,0,0,1,26.693,19.851ZM7.156,11.007h33.7v9.844H37.816a2.966,2.966,0,0,0,.184-1v-3a3,3,0,0,0-3-3H27.693a3,3,0,0,0-3,3v3a2.967,2.967,0,0,0,.185,1H23.122a2.967,2.967,0,0,0,.185-1v-3a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v3a2.966,2.966,0,0,0,.184,1H7.156ZM6,33.888V28.37H42v5.518Z"/></svg>
                        <p><strong>{{ room.number_of_bedrooms }} ×</strong> {{ $t('double_beds') }}</p>
                      </div>
                      <div class="room-spec" v-if="room.number_of_double_sofa_beds > 0">
                        <svg width="38" height="38" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>comfort</title><path d="M45.893,20.224a3.847,3.847,0,0,0-3.829-2.951,7.1,7.1,0,0,0-7.05-6.407h-22a7.1,7.1,0,0,0-7.055,6.425,3.769,3.769,0,0,0-.981.084,3.85,3.85,0,0,0-.017,7.5l.441,6.576A3.774,3.774,0,0,0,9.16,34.957h.33v1.336a1.842,1.842,0,0,0,1.84,1.841h1.635c.527,0,.987,0,2.431-3.177H32.613c1.445,3.173,1.905,3.177,2.432,3.177H36.68a1.843,1.843,0,0,0,1.84-1.841V34.957h.336a3.773,3.773,0,0,0,3.754-3.509l.441-6.574A3.859,3.859,0,0,0,46,21.112,3.921,3.921,0,0,0,45.893,20.224ZM13.017,12.866H35.011a5.092,5.092,0,0,1,5.079,5A3.8,3.8,0,0,0,38.4,20.2l-.916,3.436c-3.337-.845-6.859-.868-12.421-.849H22.919c-5.56-.019-9.064,0-12.409.855l-.9-3.386a3.829,3.829,0,0,0-1.672-2.362A5.09,5.09,0,0,1,13.017,12.866Zm23.956,12.7-.2.762a1.768,1.768,0,0,1-1.7,1.276H12.921a1.764,1.764,0,0,1-1.689-1.258l-.209-.785c3.082-.782,6.318-.788,11.9-.777h2.15C30.468,24.766,33.875,24.789,36.973,25.568ZM12.545,36.134H11.49V34.957h1.688C12.937,35.444,12.708,35.875,12.545,36.134Zm23.975,0H35.464c-.162-.259-.391-.69-.632-1.177H36.52Zm5.589-13.153a1,1,0,0,0-1,.934l-.5,7.4a1.768,1.768,0,0,1-1.759,1.643H9.16A1.768,1.768,0,0,1,7.4,31.315l-.5-7.4a1.046,1.046,0,0,0-1.046-.934h0a1.854,1.854,0,0,1-.42-3.659,1.866,1.866,0,0,1,2.233,1.417l1.638,6.143a3.775,3.775,0,0,0,3.612,2.724h22.16A3.778,3.778,0,0,0,38.7,26.863l1.645-6.174a1.853,1.853,0,0,1,3.6,0h0a1.854,1.854,0,0,1-1.839,2.29Z"/></svg>
                        <p><strong>{{ room.number_of_double_sofa_beds }} ×</strong> {{ $t('double_sofa_beds') }}</p>
                      </div>
                      <div class="room-spec" v-if="room.number_of_single_beds > 0">
                        <svg width="38" height="38" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>bed-single</title><path d="M37.461,21.829V10.007a1,1,0,0,0-1-1H11.546a1,1,0,0,0-1,1V21.821a2.981,2.981,0,0,0-.807,2.032V34.888a1,1,0,0,0,1,1h2.078v2.105a1,1,0,0,0,2,0V35.888H33.1v2.105a1,1,0,1,0,2,0V35.888h2.163a1,1,0,0,0,1-1V23.853A2.981,2.981,0,0,0,37.461,21.829ZM11.739,23.853a1,1,0,0,1,1-1H35.259a1,1,0,0,1,1,1v2.516H11.739Zm6.777-4V15.781a1,1,0,0,1,1-1h8.968a1,1,0,0,1,1,1v4.071a1,1,0,0,1-1,1H19.516A1,1,0,0,1,18.516,19.852Zm-5.97-8.845H35.461v9.845H31.3a2.971,2.971,0,0,0,.184-1V15.781a3,3,0,0,0-3-3H19.516a3,3,0,0,0-3,3v4.071a2.971,2.971,0,0,0,.184,1H12.546Zm-.807,22.881V28.369H36.261v5.519Z"/></svg>
                        <p><strong>{{ room.number_of_single_beds }} ×</strong> {{ $t('single_beds') }}</p>
                      </div>
                      <div class="room-spec" v-if="room.number_of_single_sofa_beds > 0">
                        <svg width="38" height="38" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>comfort</title><path d="M45.893,20.224a3.847,3.847,0,0,0-3.829-2.951,7.1,7.1,0,0,0-7.05-6.407h-22a7.1,7.1,0,0,0-7.055,6.425,3.769,3.769,0,0,0-.981.084,3.85,3.85,0,0,0-.017,7.5l.441,6.576A3.774,3.774,0,0,0,9.16,34.957h.33v1.336a1.842,1.842,0,0,0,1.84,1.841h1.635c.527,0,.987,0,2.431-3.177H32.613c1.445,3.173,1.905,3.177,2.432,3.177H36.68a1.843,1.843,0,0,0,1.84-1.841V34.957h.336a3.773,3.773,0,0,0,3.754-3.509l.441-6.574A3.859,3.859,0,0,0,46,21.112,3.921,3.921,0,0,0,45.893,20.224ZM13.017,12.866H35.011a5.092,5.092,0,0,1,5.079,5A3.8,3.8,0,0,0,38.4,20.2l-.916,3.436c-3.337-.845-6.859-.868-12.421-.849H22.919c-5.56-.019-9.064,0-12.409.855l-.9-3.386a3.829,3.829,0,0,0-1.672-2.362A5.09,5.09,0,0,1,13.017,12.866Zm23.956,12.7-.2.762a1.768,1.768,0,0,1-1.7,1.276H12.921a1.764,1.764,0,0,1-1.689-1.258l-.209-.785c3.082-.782,6.318-.788,11.9-.777h2.15C30.468,24.766,33.875,24.789,36.973,25.568ZM12.545,36.134H11.49V34.957h1.688C12.937,35.444,12.708,35.875,12.545,36.134Zm23.975,0H35.464c-.162-.259-.391-.69-.632-1.177H36.52Zm5.589-13.153a1,1,0,0,0-1,.934l-.5,7.4a1.768,1.768,0,0,1-1.759,1.643H9.16A1.768,1.768,0,0,1,7.4,31.315l-.5-7.4a1.046,1.046,0,0,0-1.046-.934h0a1.854,1.854,0,0,1-.42-3.659,1.866,1.866,0,0,1,2.233,1.417l1.638,6.143a3.775,3.775,0,0,0,3.612,2.724h22.16A3.778,3.778,0,0,0,38.7,26.863l1.645-6.174a1.853,1.853,0,0,1,3.6,0h0a1.854,1.854,0,0,1-1.839,2.29Z"/></svg>
                        <p><strong>{{ room.number_of_single_sofa_beds }} ×</strong> {{ $t('single_sofa_beds') }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="feat">
                    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>user</title><path d="M28.838,23.607a10.167,10.167,0,1,0-9.676,0A15.687,15.687,0,0,0,8.333,38.5h2a13.667,13.667,0,0,1,27.334,0h2A15.687,15.687,0,0,0,28.838,23.607Zm-13-8.94A8.167,8.167,0,1,1,24,22.833,8.177,8.177,0,0,1,15.833,14.667Z"/></svg>
                    <p>Up to {{ room.maximum_occupants }} {{ $t('guests') }}</p>
                  </div>
                  <div class="feat">
                    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><title>expand</title><path d="M18.749,40.842l-9.572-.018a2.01,2.01,0,0,1-2-2l-.018-9.573,2,0L9.173,37.4,21.742,24.828l1.414,1.414L10.575,38.823l8.178.019Zm7.509-17.67-1.414-1.414L37.425,9.177l-8.178-.019,0-2,9.572.018a2.01,2.01,0,0,1,2,2l.018,9.573-2,0L38.827,10.6Z"/></svg>
                    <p>{{ room.room_size }}m² {{ $t('size') }}</p>
                  </div>
                </div>
                <a :href="room.permalink | formatPermalink" class="apartment-info">
                  {{ $t('apartment_information') }}
                </a>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <div v-if="cityName && cityPermalink">
            <p class="error-message">
              {{ $t('no_availability_for_criteria') }}<br/>
              {{ $t('amend_search_criteria') }} <span>{{ $t('find_properties_in') }} {{ cityName }} {{ $t('with_availability_for_criteria') }}</span><br/>
              <a :href="cityPermalink | formatPermalink" class="button">{{ $t('find_properties') }}</a>
            </p>
          </div>

          <div v-if="! (cityName || cityPermalink)">
            <p class="error-message">{{ $t('no_availability') }}</p>
          </div>
        </template>
      </template>

      <availability-filters
          v-if="features !== null && numberOfAdults !== null && numberOfChildren !== null"
          :initialFeatures="features"
          :initialNumberOfAdults="numberOfAdults"
          :initialNumberOfChildren="numberOfChildren"
          :initialNumberOfRooms="1"
          :maximumNumberOfAdults="maximumNumberOfAdults"
          :maximumNumberOfChildren="maximumNumberOfChildren"
          :maximumNumberOfGuests="maximumNumberOfGuests"
          :maximumNumberOfRooms="maximumNumberOfRooms"
          :minimumNumberOfAdults="minimumNumberOfAdults"
          :minimumNumberOfChildren="minimumNumberOfChildren"
          :minimumNumberOfRooms="minimumNumberOfRooms"
          :showCart="true"
          :showGroupSelector="false"
          @change="filterRooms"
      />
    </div>
</template>

<script>
import AvailabilityFilters from './AvailabilityFilters.vue';
import filterMixin from '@/mixins/filterMixin';
import {
  getNumberWithinRangeElseDefault,
  areFeaturesValid,
  isNumberOfGuestsValid,
} from '@/utils/BookingDetailValidationUtil'

export default {
  mixins: [
    filterMixin,
  ],
  data() {
    /* global wpData:true */
    /* eslint no-undef: "error" */
    return {
      apartmentListingKey: Number(new Date()),
      cityName: "",
      cityPermalink: "",
      defaultNumberOfAdults: 2,
      defaultNumberOfChildren: 0,
      defaultNumberOfInfants: 0,
      detailsLink: "/enter-details",
      features: '',
      loading: false,
      maximumNumberOfAdults: 10,
      maximumNumberOfChildren: 10,
      maximumNumberOfInfants: 10,
      maximumNumberOfGuests: 10,
      maximumNumberOfRooms: 4,
      minimumNumberOfAdults: 1,
      minimumNumberOfChildren: 0,
      minimumNumberOfInfants: 0,
      minimumNumberOfRooms: 1,
      numberOfAdults: null,
      numberOfChildren: null,
      numberOfInfants: null,
      rooms: [],
      filteredRooms: [],
      translations: null,
      wpData,
    };
  },
  components: {
    'availability-filters': AvailabilityFilters
  },
  async mounted() {
    this.setLocale();

    this.rooms = this.wpData.rooms || []
    this.filteredRooms = this.wpData.rooms || []

    this.initialiseBookingDetails();
  },
  methods: {
    initialiseBookingDetails() {
      this.numberOfAdults = getNumberWithinRangeElseDefault(
          this.wpData.query_parameters.minAdults,
          this.defaultNumberOfAdults,
          this.minimumNumberOfAdults,
          this.maximumNumberOfAdults
      );

      this.numberOfChildren = getNumberWithinRangeElseDefault(
          this.wpData.query_parameters.minChildren,
          this.defaultNumberOfChildren,
          this.minimumNumberOfChildren,
          this.maximumNumberOfChildren
      );

      this.numberOfInfants = getNumberWithinRangeElseDefault(
          this.wpData.query_parameters.minInfants,
          this.defaultNumberOfInfants,
          this.minimumNumberOfInfants,
          this.maximumNumberOfInfants
      );

      if (areFeaturesValid(this.wpData.query_parameters.features)) {
        this.features = this.wpData.query_parameters.features;
      } else {
        this.features = '';
      }

      this.filterRooms()
    },
    filterRooms(event = {}) {
      if (event.emittedFromDatePicker === true) {
        this.apartmentListingKey = event.currentDateSelectionKey

        return
      }

      this.numberOfAdults = event.numberOfAdults || this.numberOfAdults
      this.numberOfChildren = event.numberOfChildren || this.numberOfChildren
      this.features = event.features || ''

      this.loading = true
      setTimeout(() => this.loading = false, 600)

      this.filteredRooms = this.rooms.filter(
          (room) => {
            const features = room.autoloaded_features || []

            const roomFeatures = features.map(feature => feature.value)

            const selectedFeatures = this.features.split(',').filter(feature => feature.length)
            const doesRoomMatchSomeSelectedFilters = selectedFeatures.some(feature => roomFeatures.includes(feature))

            if (selectedFeatures.length !== 0 && doesRoomMatchSomeSelectedFilters === false) {
              return false
            }

            return isNumberOfGuestsValid(
                this.numberOfAdults,
                this.numberOfChildren,
                this.numberOfInfants,
                Number(room.maximum_occupants)
            )
          }
      )
    },
    setLocale() {
      const url = new URL(window.location.href);
      const language = url.searchParams.get('lang');

      this.$i18n.locale = document.getElementsByTagName('html')[0].getAttribute('lang');

      if (this.$i18n.availableLocales.indexOf(language) === -1) {
        this.translations = this.$i18n.messages[this.$i18n.fallbackLocale];
      } else {
        this.translations = this.$i18n.messages[language];
      }
    },
  },
  computed: {
    showNoAvailabilityErrorMessage: function() {
      return this.filteredRooms.length === 0
    },
  },
}
</script>
